import { RENTAL_PORTAL_VIEWING_STATUS } from '../../../../../constants/rentalPortal'

export function getIsViewingStatusNoShow(status) {
  return status === RENTAL_PORTAL_VIEWING_STATUS.noShow
}
